import { message } from 'antd';
import { config } from 'util/config';
import { httpClient } from "util/Api";
import * as globalFunction from 'util/GlobalFunction';

export function getSectionDataByDefault({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  pageComponent.setState({ defaultFormData: { moduleId: parameter } });
  let componentDefaultValue = { ...sectionComponent.state.componentDefaultValue };
  componentDefaultValue[uie.source] = parameter;
  sectionComponent.setState({ searchParameter: { moduleId: parameter }, componentDefaultValue });
  sectionComponent.customForm.current?.setState({ componentDefaultValue: [], componentDataSource: [] });
  setTimeout(() => {
    sectionComponent.getSectionDataByDefault();
  }, config.setTimeoutMilliSecond);
}

//通过 Favorite 修改 icon
export function formatData({ parameter } = {}) {
  let data = parameter.map((item, i) => {
    let iconFormat = [];
    if (item.Favorite) {
      //如果 Favorite 是 true, actionType 是 UpdateFavorite 的 图标设置用第2个图片
      iconFormat.push({ actionType: 'UpdateFavorite', iconIndex: 1 });
    }
    if (iconFormat.length > 0) item.IconFormat = iconFormat;
    return item;
  })
  return data;
}

// 分组表格内的模板同样需要根据 Favorite 状态更新图标。
export function formatGroupData({ parameter } = {}) {
  return parameter.map((group) => {
    group.DataList = formatData({ parameter: group.DataList });
    return group;
  });
}

export function addNoteTemplatePopUpRun({ sectionComponent } = {}) {
  setGroupNameDataSource({ sectionComponent });
}

export function editNoteTemplatePopUpRun({ sectionComponent } = {}) {
  setGroupNameDataSource({ sectionComponent });
}

function setGroupNameDataSource({ sectionComponent } = {}) {
  const options = [];
  sectionComponent.child?.current?.state.data?.forEach((item) => {
    if (item.key !== 0) {
      options.push({ label: item.Name, value: item.Name });
    }
  });

  setTimeout(() => {
    const componentDataSource = { ...sectionComponent.customForm.current.state.componentDataSource };
    componentDataSource.GroupName = options;
    sectionComponent.customForm.current.setState({ componentDataSource });
  }, config.setTimeoutMilliSecond);
}

//更新 Favorite 状态
export function updateFavorite({ sectionName, parameter, sectionComponent, pageComponent, uie } = {}) {
  httpClient
    .put('Admin/NoteTemplate/UpdateFavorite', parameter)
    .then(({ data }) => {
      if (data.result) {
        sectionComponent.getSectionDataByDefault();
      } else {
        globalFunction.handleResultError(data, pageComponent);
      }
    })
    .catch(function (error) {
      globalFunction.handleError(error, pageComponent);
    });
}
